

import { Grid, TextField } from "@mui/material";
import { BotonesAndCargando } from "../botones/BotonesAndCargando";
import { useRef, useState } from "react";
import { AutocompleteConLoading } from "../inputs/AutocompleteConLoading";
import { startProductosTodos, startSavingItemCompra } from "../../../services";
import { useModalesStore } from "../../../store";
import { useQueryClient } from "@tanstack/react-query";

import Swal from "sweetalert2";




export const FormularioSolicitudes = () => {


    const debounceRef = useRef(null);
    const queryClient = useQueryClient();
    const { changeEstadoModalUno } = useModalesStore();
    
    const [cargando, setCargando] = useState(false);
    const [optiones, setOpciones] = useState([]);
    const [formValues, setFormValues] = useState({ producto: '', cantidad: '' });
    const { producto, cantidad } = formValues;



    const buscarInfo = (texto) => {
        if(debounceRef.current){ clearTimeout(debounceRef.current); }
        debounceRef.current = setTimeout(async () => {
            const query = texto.trim();
            if (query.length === 0) return;
            setCargando(true);
            const respuesta = await startProductosTodos(texto);
            setOpciones(respuesta)
            setCargando(false);
        }, 700);
    };


    const handleChanges = ({ target: { name, value } }) => {
        setFormValues(prev => ({ ...prev, [name]: value }));
    };



    const crearActInformacion = async(e) => {
        e.preventDefault();
        if([producto, cantidad].includes('') ){
            return Swal.fire('Error', 'Formulario Incorrecto por favor llene todos los campos', 'error');
        }

        await Swal.fire({
            title: `Crear Item de Compra`,
            text: `¿Esta seguro de generar este item para compra?`,
            icon: 'question',
            showCancelButton: true,
            confirmButtonText: `Si, realizar`
        }).then( async( _ ) => {
            const resp = await startSavingItemCompra({producto, cantidad});
            if(resp){
                setFormValues({ producto: '',  cantidad: '' });
                changeEstadoModalUno(false);
                queryClient.invalidateQueries({queryKey: ['items-compra']});
            }
        });
    }



    return (
        <form onSubmit={ crearActInformacion } >
            <Grid container spacing={ 2 }>

                <Grid item xs={12}>
                    <AutocompleteConLoading
                        size="small"
                        label="Producto" 
                        placeholder='Producto' 
                        fullWidth
                        name="producto"
                        options={optiones}
                        value={ producto }
                        onChange={handleChanges}
                        loading={cargando}
                        handleFunction={ (value) => buscarInfo(value) }
                    />
                </Grid>

                <Grid item xs={12}>
                    <TextField
                        type="number"
                        label='Cantidad'
                        fullWidth
                        size="small"
                        name='cantidad'
                        value={ cantidad }
                        onChange={ handleChanges }
                    />
                </Grid>

            </Grid>


            <Grid container sx={{mt:3, mb:2, display:'flex', justifyContent:'center' }}>
                <Grid item xs={12} sm={6} md={5}>
                    <BotonesAndCargando
                        cargando={cargando}
                        titulo={'Crear'}
                        titulo2="Loading..."
                        icon1="save"
                        icon2="save"
                        type="submit"
                    />
                </Grid>
            </Grid>
        </form>
    )
}
